<ng-container *ngIf="expandMenuDrawer$ | async" />
<div
  class="h-full st-side-menu-drawer overflow-hidden"
  zSideDrawer
  [isOpen]="isOpen()"
  [direction]="'left'"
  [maxWidth]="this.maxWidth()"
>
  <z-mobile-main-sections-left-menu
    [homeButton]="homeButton()"
    [navigationList]="navigationList()"
    [profile]="profile()"
    [settingURL]="settingURL()"
    [tools]="tools()"
    (onSelectSection)="selectionItem($event)"
    [@drawerState]="!showContent() ? 'open' : 'closed'"
    [style.width]="this.maxWidth()"
    (onToolsOpen)="openTools()"
    [dashboardRoutes]="dashboardRoutes()"
    [settingsRoutes]="settingsRoutes()"
    [hideTools]="hideTools()"
  />
  <z-menu-drawer-section-content
    [navigationItem]="this.navigationItem()"
    [style.width]="this.maxWidth()"
    (onHideContent)="hideContent()"
    [@drawerContentState]="showContent() ? 'open' : 'closed'"
    [tools]="toolsContent()"
    [dashboardRoutes]="dashboardRoutes()"
    [hideTools]="hideTools()"
  />
</div>
